export function filterSetupData(data, allowed) {
  return allowed.reduce((acc, key) => {
    if (data[key] !== undefined) {
      acc[key] = data[key];
    }
    return acc;
  }, {});
}
